export const AppConfig = {
  CORE_API_URL: '/',
  GOOGLE_API_KEY: 'AIzaSyD70AUbJYki6FOfA0ap86AWWRgxsdL62iY'
}
